import { requests as authentications } from './authentication'
import { requests as job_schedule_worker_cancel_histories } from './job_schedule_worker_cancel_histories'
import { requests as job_schedules } from './job_schedules'
import { requests as jobs } from './jobs'
import { requests as message_rooms } from './message_rooms'
import { requests as messages } from './messages'
import { requests as mp_business_commission_jobs } from './mp_business_commission_jobs'
import { requests as mp_employment_jobs } from './mp_employment_jobs'
import { requests as workers } from './workers'
import { requests as industries } from './industries'
import { requests as occupations } from './occupations'
import { requests as qualifications } from './qualifications'
import { requests as languages } from './languages'
import { requests as job_candidates } from './job_candidates'
import { requests as job_applications } from './job_applications'
import { requests as favorites } from './favorites'
import { requests as jobScouts } from './job_scouts'
import { requests as request_qualification_certificates } from './request_qualification_certificates'
import { requests as staffs } from './staffs'
import { requests as branches } from './branches'
import { requests as branch_reviews } from './branch_reviews'
import { requests as branch_candidate_tags } from './branch_candidate_tags'
import { requests as places } from './places'
import { requests as recruitment_flows } from './recruitment_flows'
import { requests as payment_histories } from './payment_histories'
import { requests as subscriptions } from './subscriptions'
import { requests as notifications } from './notifications'
import { requests as announcements } from './announcements'
import { requests as mp_employment_job_change_logs } from './mp_employment_job_change_logs'
import { requests as recruitment_offers } from './recruitment_offers'
import { requests as worker_fee_update_applications } from './worker_fee_update_applications'
import { requests as trackings } from './trackings'
import { requests as postals } from './postals'
import { requests as company_contents } from './company_contents'
import { requests as company_content_images } from './company_content_images'
import { requests as branch_minds } from './branch_minds'
import { requests as worker_minds } from './worker_minds'
import { requests as auto_branch_mind_conditions } from './auto_branch_mind_conditions'
import { requests as browses } from './browses'
import { requests as branch_feed_contents } from './branch_feed_contents'
import { requests as branch_free_plan_limits } from './branch_free_plan_limits'
import { requests as branch_contact_workers } from './branch_contact_workers'
import { requests as user_activities } from './user_activities'
import { requests as branch_terms } from './branch_terms'
import { requests as recruitment_steps } from './recruitment_steps'
import { requests as spotwork_jobs } from './spotwork_jobs'
import { requests as spotwork_job_job_applications } from './spotwork_jobs/job_applications'
import { requests as spotwork_job_job_schedules } from './spotwork_jobs/job_schedules'
import { requests as spotwork_job_job_schedule_worker_cancel_histories } from './spotwork_jobs/job_schedule_worker_cancel_histories'

export const apis = {
  authentications,
  job_schedule_worker_cancel_histories,
  job_schedules,
  jobs,
  message_rooms,
  messages,
  mp_business_commission_jobs,
  mp_employment_jobs,
  workers,
  staffs,
  industries,
  occupations,
  places,
  qualifications,
  recruitment_flows,
  languages,
  job_candidates,
  job_applications,
  favorites,
  jobScouts,
  request_qualification_certificates,
  branches,
  branch_reviews,
  branch_candidate_tags,
  payment_histories,
  subscriptions,
  notifications,
  announcements,
  mp_employment_job_change_logs,
  recruitment_offers,
  worker_fee_update_applications,
  trackings,
  postals,
  company_contents,
  company_content_images,
  branch_minds,
  worker_minds,
  auto_branch_mind_conditions,
  browses,
  branch_feed_contents,
  branch_free_plan_limits,
  branch_contact_workers,
  user_activities,
  branch_terms,
  recruitment_steps,
  spotwork_jobs,
  spotwork_job_job_applications,
  spotwork_job_job_schedules,
  spotwork_job_job_schedule_worker_cancel_histories,
}
